import { container } from "@di/inversify.config";
import { AuthenticatedUserIsLoggedUseCase } from "@iot-platform/authentication";
import { HomeRoutes } from "@routes/private/home.routes";
import type { FC } from "react";
import { Navigate, Outlet } from "react-router";

export const LoginFromTokenGuard: FC = () => {
    const isUserLogged = container
        .get(AuthenticatedUserIsLoggedUseCase)
        .execute();

    return isUserLogged ? (
        <Navigate
            to={HomeRoutes.HOME}
            replace
        />
    ) : (
        <Outlet />
    );
};
